import { Link, useLocation } from "wouter";
import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";
import { RefreshCw } from "lucide-react";

export interface SubNavTab {
  label: string;
  path: string;
  badge?: number; // Optional badge count
}

interface SubNavProps {
  tabs: SubNavTab[];
  onRefresh?: () => void;
  isRefreshing?: boolean;
}

export const SubNav = ({ tabs, onRefresh, isRefreshing = false }: SubNavProps) => {
  const [location] = useLocation();

  return (
    <div className="border-b bg-white">
      <nav className="flex items-center justify-between px-6" aria-label="Sub navigation">
        <div className="flex gap-1">
          {tabs.map((tab) => {
            const isActive = location === tab.path || location.startsWith(tab.path + '/');

            return (
              <Link key={tab.path} href={tab.path}>
                <button
                  className={cn(
                    "relative px-4 py-3 text-sm font-medium transition-colors",
                    "border-b-2 -mb-px",
                    isActive
                      ? "border-blue-600 text-blue-600"
                      : "border-transparent text-gray-600 hover:text-gray-900 hover:border-gray-300"
                  )}
                >
                  {tab.label}
                  {tab.badge !== undefined && tab.badge > 0 && (
                    <span className="ml-2 inline-flex items-center justify-center px-2 py-0.5 text-xs font-bold leading-none text-white bg-blue-600 rounded-full">
                      {tab.badge}
                    </span>
                  )}
                </button>
              </Link>
            );
          })}
        </div>

        {onRefresh && (
          <Button
            variant="ghost"
            size="sm"
            onClick={onRefresh}
            disabled={isRefreshing}
            className="my-2"
          >
            <RefreshCw className={`h-4 w-4 ${isRefreshing ? 'animate-spin' : ''}`} />
          </Button>
        )}
      </nav>
    </div>
  );
};
